import { IDocumentStatus } from '@tap/data-providers';
import { StatusChip, StatusChipVariant } from '@tap/tap-ui';

export const StatusFieldCell = ({
    value,
}: {
    value?: IDocumentStatus,
}) => {
    if (!value)
        return <>-</>;

    return (
        <StatusChip
            styleCode={value.styleCode}
            statusName={value.name}
            variant={StatusChipVariant.WithIcon}
        />
    )
}